<template>
<div class="sw--position-relative"
     v-on:mouseleave="closeTools">
    <div v-if="toolsOpen"
         v-bind:class="containerClass"
         class="sw--position-absolute
                sw--padding-top-5
                sw--padding-hor-3
                z-index-10">
      <div class="sw--border-grey-1 sw-dms--bg-white sw--border-radius-3 sw--box-shadow-1 sw--translate-z-0">
        <nav class="sw--padding-vert-1 sw--font-size-12">
          <ul class="sw--list-style-none sw--margin-left-0">
            <li v-if="showUpdateModel">
              <a v-on:click="updateModel"
                 event-action="Tools"
                 event-label="Update"
                 class="sw-user-account-widget__link sw--padding-vert-2 sw--padding-hor-5 sw-grid-flex sw-grid-flex--align-center">
                <span class="icon-upload sw--font-size-22 sw-dms--color-grey-46"></span>
                <span class="sw--display-block
                                 sw-dms--text-dark
                                 sw--margin-left-2
                                 sw--font-size-14
                                 sw--white-space-no-wrap">Update</span>
              </a>
            </li>
            <!--
            <li>
              <a v-bind:href="threeDToolsUrl"
                 event-action="Tools"
                 event-label="Open in 3D tools"
                 class="sw-user-account-widget__link sw--padding-vert-2 sw--padding-hor-5 sw-grid-flex sw-grid-flex--align-center">
                <span class="icon-3d-rotate sw--font-size-22 sw-dms--color-grey-46"></span>
                <span class="sw--display-block
                                 sw-dms--text-dark
                                 sw--margin-left-2
                                 sw--font-size-14
                                 sw--white-space-no-wrap">Open in 3D tools</span>
              </a>
            </li>
            -->
            <li>
              <a data-sw-noty
                 v-bind:data-sw-noty-id="modelRenameNotyId"
                 v-bind:data-sw-noty-href="modelRenameUrl"
                 data-sw-noty-timeout="false"
                 data-sw-noty-type="content"
                 data-sw-noty-layout="swCenterContent"
                 data-sw-noty-modal="true"
                 data-sw-noty-close-with='["backdrop"]'
                 event-action="Tools"
                 event-label="Rename"
                 class="sw-user-account-widget__link
                            sw--padding-vert-2
                            sw--padding-hor-5
                            sw-grid-flex
                            sw-grid-flex--align-center">
                <span class="icon-pencil sw--font-size-22 sw-dms--color-grey-46"></span>
                <span class="sw--display-block
                                 sw-dms--text-dark
                                 sw--margin-left-2
                                 sw--font-size-14
                                 sw--white-space-no-wrap">Rename</span>
              </a>
            </li>
            <li>
              <a v-bind:href="downloadUrl"
                 event-action="Tools"
                 event-label="Download"
                 class="sw-user-account-widget__link sw--padding-vert-2 sw--padding-hor-5 sw-grid-flex sw-grid-flex--align-center">
                <span class="icon-download-2 sw--font-size-22 sw-dms--color-grey-46"></span>
                <span class="sw--display-block
                                 sw-dms--text-dark
                                 sw--margin-left-2
                                 sw--font-size-14
                                 sw--white-space-no-wrap">Download</span>
              </a>
            </li>
            <li v-if="editProductUrl">
              <a v-bind:href="editProductUrl"
                 event-action="Tools"
                 event-label="Edit Product"
                 class="sw-user-account-widget__link sw--padding-vert-2 sw--padding-hor-5 sw-grid-flex sw-grid-flex--align-center">
                <span class="icon-models sw--font-size-22 sw-dms--color-grey-46"></span>
                <span class="sw--display-block
                                 sw-dms--text-dark
                                 sw--margin-left-2
                                 sw--font-size-14
                                 sw--white-space-no-wrap">Edit Product</span>
              </a>
            </li>
            <li v-else>
              <a v-bind:href="createProductUrl"
                 event-action="Tools"
                 event-label="Create A Product"
                 class="sw-user-account-widget__link sw--padding-vert-2 sw--padding-hor-5 sw-grid-flex sw-grid-flex--align-center">
                <span class="icon-models sw--font-size-22 sw-dms--color-grey-46"></span>
                <span class="sw--display-block
                                 sw-dms--text-dark
                                 sw--margin-left-2
                                 sw--font-size-14
                                 sw--white-space-no-wrap">Create A Product</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="sw--cursor-pointer" v-on:click="openTools">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import sw from 'js/lib/sw';
  import $ from 'js/sw-jquery/sw-jquery';

  const swFragmentLoad = (vueInstance) => {
    vueInstance.$nextTick(() => {
      sw.trigger('sw-fragment-loaded', $(vueInstance.$el));
    });
  };

  export default {
    name: 'sw-model-tools',
    props: {
      'modelId': {type: Number, required: true},
      'showUpdateModel': Boolean,
      'modelRenameNotyId': String,
      'modelRenameUrl': String,
      'threeDToolsUrl': String,
      'downloadUrl': String,
      'editProductUrl': String,
      'createProductUrl': String,
      'containerClass': String
    },
    data() {
      return {
        toolsOpen: false
      }
    },
    mounted() {
      swFragmentLoad(this);
    },
    updated() {
      swFragmentLoad(this);
    },
    methods: {
      openTools() {
        this.toolsOpen = true;
      },
      closeTools() {
        this.toolsOpen = false;
      },
      updateModel() {
        this.$emit('update-model');
      }
    }
  }
</script>
